import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { selectTodayStudyHistoryDateKey } from '../slices/todayStudyHistory/todayStudyHistorySlice';
import { refreshTodayStudyHistoryIfStale } from '../services/stats';

/**
 * Loads today's study counters on any surface that gates on the free-plan
 * daily limits (QBank, videos, chat questions).
 *
 * The counters are fetched for a single day and are not persisted, so a
 * surface reached without passing through Home would otherwise gate on a
 * previous day's totals or on no data at all (ORA-319). The refresh is a no-op
 * once the data is loaded for the current day.
 */
export const useEnsureTodayStudyHistory = () => {
  const dateKey = useSelector(selectTodayStudyHistoryDateKey);

  useEffect(() => {
    void refreshTodayStudyHistoryIfStale();
  }, [dateKey]);
};
